angular.module('chat2')

    /**
     *
     */

    .directive('mimeMessagePart', ["$stateParams", "$compile", "$templateRequest", "formService", "utilService", "$sce", "whatsAppServices", "whatsAppSharedService",
        function ($stateParams, $compile, $templateRequest, formService, utilService, $sce, whatsAppServices, whatsAppSharedService) {

            function link(scope, element, attrs) {
                
                function containsUnicodeEmoji(str) {
                    
                    var regex = /[\uD83C-\uDBFF\uDC00-\uDFFF]+/g;
                    var match = regex.exec(str);

                    if (match) {
                        return true;
                    } else {
                        return false;
                    }
                };

                /**
                 * 
                 */
                function getAttachmentLink() {
                    if (scope.part.data) {
                        return "data:" + scope.part.type + ";base64," + scope.part.data;
                    } else if (scope.part.url) {
                        return scope.part.url;
                    } else {
                        return "";
                    }
                }

                /**
                 * 
                 */
                function getTextClass() {
                    return (containsUnicodeEmoji(scope.part.data) &&
                        scope.part.data.length < 6
                    )
                        ? "chatText emoji" : "chatText";
                }

                var _type = scope.part.type || "text/plain";
                var split = _type.split('/');

                scope.type = split[0];
                scope.subType = split[1];
                scope.showEllipsis = false;
                
                scope.hideEllipsisButton= function(){
                    scope.showEllipsis = false;
                };
                
                scope.showEllipsisButton = function(){
                    scope.showEllipsis = true;
                }

                
                var templateUrl;
                switch (scope.type) {

                    case "text":
                        if (scope.part.data) {
                            templateUrl = "components/toolkit/chat/templates/messageParts/text.html";
                            scope.body = utilService.linkify(scope.part.data);
                            if(scope.body === "--MessageRemoved--"){
                                scope.body = 'This message has been deleted';
                            }
                            scope.textClass = getTextClass();
                        } else {
                            templateUrl = "components/toolkit/chat/templates/messageParts/attachment.html";
                            scope.attachmentLink = getAttachmentLink();
                        }
                        break;

                    case "image":
                        templateUrl = "components/toolkit/chat/templates/messageParts/image.html";
                        scope.attachmentLink = getAttachmentLink();
                        break;


                    case "comapi":
                        if (scope.subType === "form") {
                            templateUrl = "components/toolkit/chat/templates/messageParts/form.html";

                            // TODO: populate formId, getFormUrl;
                            if (scope.part.data) {
                                try {
                                    var data = JSON.parse(scope.part.data);
                                    scope.formUrl = data.url;
                                    scope.formId = data.id;
                                } catch (e) {
                                    scope.formUrl = scope.part.data;
                                    var bits = scope.part.data.split('/');
                                    scope.formId = bits[bits.length - 1];
                                }
                            } else {
                                scope.formUrl = scope.part.url;
                                var bits = scope.part.url.split('/');
                                scope.formId = bits[bits.length - 1];
                            }


                            formService.getForm($stateParams.pickedApiSpaceId, scope.formId)
                                .then(function (result) {
                                    scope.formData = result.data;
                                    scope.formTitle = result.schema.title;
                                });
                        } else if(scope.subType === "location") {
                            templateUrl = "components/toolkit/chat/templates/messageParts/location.html";
                            var latitude = scope.part.data.latitude; 
                            var longitude = scope.part.data.longitude;
                            var top =  latitude + 0.001;
                            var bottom =  latitude - 0.001;
                            var left =  longitude + 0.002;
                            var right =  longitude - 0.002;
                            var url = "https://www.openstreetmap.org/export/embed.html?bbox="+left+","+bottom+","+right+","+top+"&marker="+latitude+","+longitude+"&layers=ND";
                            scope.mapUrl = $sce.trustAsResourceUrl(url);
                        }
                        break;
                    case "video": 
                        templateUrl = "components/toolkit/chat/templates/messageParts/video.html";
                        scope.videoUrl = scope.part.url;
                        scope.videoType = scope.part.type
                        break;
                    case "audio": 
                        templateUrl = "components/toolkit/chat/templates/messageParts/audio.html";
                        scope.audioUrl = scope.part.url;
                        scope.audioType = scope.part.type
                        break;
                    case "whatsapp":
                        if(scope.subType === "hsm" || scope.subType === "template"){
                            if(scope.message && scope.message.message && scope.message.message.body){
                                scope.hsm = scope.message.message.body
                            } else {
                                whatsAppServices.getHsm($stateParams.pickedApiSpaceId, scope.part.data.templateName).then(function(hsm){
                                    if(!hsm){
                                        scope.hsm = "--Failed to send - template '" + scope.part.data.templateName + "'--";
                                    } else if (hsm && !hsm.messages[scope.part.data.languageCode]) {
                                        scope.hsm = "--Failed to send - template '" + scope.part.data.templateName + "' with language code '" + scope.part.data.languageCode + "'--";
                                    } else {
                                        scope.hsm = whatsAppSharedService.hsmPreview(hsm.messages[scope.part.data.languageCode], scope.part.data.parameters);
                                    }
                                });
                            }
                            templateUrl = "components/toolkit/chat/templates/messageParts/hsm.html";
                        }
                        break;
                    default:
                        templateUrl = "components/toolkit/chat/templates/messageParts/attachment.html";
                        scope.attachmentLink = getAttachmentLink();
                        break;
                }

                $templateRequest(templateUrl).then(function (html) {
                    var el = $compile(html)(scope);
                    element.append(el);
                });

            };

            return {
                restrict: 'EA',
                link: link,
                scope: {
                    part: '=',
                    disableDownload: '=?',
                    message: '=',
                    deleteCallback: '=',
                    allowDelete: '=',
                    teamAvatar: '<',
                    avatar: '<'
                }
            };

        }]);